import React from 'react'
import { css } from '@emotion/react'
import { Button } from '@livechat/design-system-react-components'
import { string } from 'prop-types'

import { getDesignationLabel, getProductIFrameUrl } from '@/utils/products'

import NotInstallableButton from './NotInstallableButton'

const infoCss = css`
  margin-top: 0;
`

const InactiveLicense = ({ designation, ...props }) => {
  const iframeUrl = getProductIFrameUrl(designation)
  const designationLabel = getDesignationLabel(designation)

  return (
    <NotInstallableButton {...props}>
      <>
        <p css={infoCss}>
          It seems like you haven't used {designationLabel} yet. You might want
          to give it a try.
        </p>
        <a
          href={iframeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="link"
        >
          <Button
            size="compact"
            kind="primary"
            fullWidth
            className="confirm-button"
          >
            Go to {designationLabel}
          </Button>
        </a>
      </>
    </NotInstallableButton>
  )
}

InactiveLicense.propTypes = {
  designation: string,
}

export default InactiveLicense
